import React from 'react';
import { SectionSummaryHSP } from '@/components/SectionSummary';
import SectionSubtitle from '@/components/Typography/SectionSubtitle';

export const RaportHSPRecommendationsWarnings: React.FC = () => {
  return (
    <div className="mt-6 space-y-8 lg:mt-10">
      <SectionSubtitle title="Wykryte ostrzeżenia" />

      <div className="flex flex-col gap-8">
        <SectionSummaryHSP
          content="Wykryto znaczące problemy z układem hamulcowym oraz zawieszeniem. Pojazd wymaga natychmiastowej naprawy przed dalszą eksploatacją."
          title="Poważne uszkodzenia mechaniczne"
          variant="danger"
          recommendation="Sprawdź jakość wykonanej naprawy"
        />
        <SectionSummaryHSP
          content="Odnotowano rozbieżności w zapisach przebiegu pojazdu. Różnica między kolejnymi pomiarami wskazuje na możliwą manipulację licznika."
          recommendation="Przeprowadź szczegółową weryfikację historii przebiegu"
          title="Niezgodność przebiegu z danymi historycznymi"
          variant="warning"
        />
        <SectionSummaryHSP
          content="Pojazd był regularnie serwisowany zgodnie z zaleceniami producenta. Wszystkie przeglądy wykonywane w autoryzowanych serwisach."
          title="Historia serwisowa bez zastrzeżeń"
          variant="success"
        />
      </div>
    </div>
  );
};
